var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "note_wrap_cont", attrs: { id: "wrap" } }, [
    _vm.lockFlag && _vm.contFlag
      ? _c("div", { staticClass: "note-tool" }, [
          _c(
            "div",
            { staticClass: "note-text" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  resize: "none",
                  placeholder: "在此记录你的想法...",
                  maxlength: "2000"
                },
                nativeOn: {
                  keydown: function($event) {
                    return _vm.listen($event)
                  }
                },
                model: {
                  value: _vm.noteCont,
                  callback: function($$v) {
                    _vm.noteCont = $$v
                  },
                  expression: "noteCont"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bottom" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v("公开")]
                  ),
                  _vm._v(" "),
                  _vm.flag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.noteCont },
                          on: {
                            click: function($event) {
                              return _vm.addNote()
                            }
                          }
                        },
                        [_vm._v("保存")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.noteCont },
                          on: {
                            click: function($event) {
                              return _vm.editorNote()
                            }
                          }
                        },
                        [_vm._v("保存")]
                      )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$store.state.flag
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "note-list"
                },
                _vm._l(_vm.noteList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "note-list-item" },
                    [
                      _c("div", { staticClass: "top" }, [
                        _c("img", {
                          attrs: { src: "/static/img/study/icon/zhangjie.png" }
                        }),
                        _vm._v(" "),
                        _c("span", { attrs: { title: item.catalogName } }, [
                          _vm._v(_vm._s(item.catalogName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "status" }, [
                        _c("span", { style: _vm.handleStatus(item.noteType) }, [
                          _vm._v(_vm._s(item.noteType))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "note-content" },
                        [
                          _c("span", {
                            staticClass: "m-content overflow-line",
                            domProps: {
                              innerHTML: _vm._s(_vm.handleNote(item.content))
                            }
                          }),
                          _vm._v(" "),
                          (item.content.length > 51
                          ? (_vm.isShowMore = true)
                          : (_vm.isShowMore = false))
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn-more",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showmoreDesc($event)
                                    }
                                  }
                                },
                                [_vm._v("展开")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom" }, [
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(item.date))
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "right" }, [
                          _c(
                            "li",
                            {
                              staticClass: "note_editor",
                              on: {
                                click: function($event) {
                                  return _vm.editNote(item, index)
                                }
                              }
                            },
                            [_c("div")]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "delete",
                              on: {
                                click: function($event) {
                                  return _vm.delNote(item.noteId)
                                }
                              }
                            },
                            [_c("div")]
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ])
      : !_vm.lockFlag
      ? _c("div", { staticClass: "noList" }, [
          _vm._v("\n  \t\t章节已锁定\n  \t")
        ])
      : !_vm.contFlag
      ? _c("div", { staticClass: "noList" }, [_vm._v("\n\t\t\t暂无数据\n\t\t")])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e569cb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e569cb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/Learning_details/note.vue
// module id = null
// module chunks = 